import { createSelector } from 'reselect'

export const shouldShowMagazineArticle = createSelector(
  (state: App.State) => state.content.magazineArticles,
  (magazineArticles: App.ContentMagazineArticlesState): boolean => magazineArticles.posts.length >= 2,
)
